import { EmbeddedRouteName, ProductType } from '@/shared/enums';
import { state } from '@/shared/components/player/store';

export default {
  methods: {
    updateEmbeddedRoute(product) {
      if (!state.isEmbedded) {
        return;
      }

      if (product.type === ProductType.PROGRAMME) {
        this.$router.push({
          name: EmbeddedRouteName.PLAYER_WITH_ARTICLE,
          params: {
            slug: 'live',
            type: ProductType.LIVE.toLowerCase(),
            id: product.channelId,
            articleSlug: product.slug,
            articleType: product.type.toLowerCase(),
            articleId: product.id,
          },
          query: this.$route.query,
        });
      } else {
        this.$router.push({
          name: EmbeddedRouteName.PLAYER,
          params: {
            slug: product.slug,
            type: product.type.toLowerCase(),
            id: product.id,
          },
          query: this.$route.query,
        });
      }
    },
  },
};
